// ── Per-page step arrays (used by PageTourButton on each page) ──

export const getDashboardSteps = () => [
  {
    element: '.gh-dashboard',
    title: 'Welcome to Your Dashboard',
    intro:
      'This is your recruiting command center. At a glance you can see how many messages you\u2019re sending and receiving, how your interviews are tracking, and how your contact list is growing. Everything updates in real time, so you always know where things stand.',
  },
  {
    element: '.gh-dash-kpi-row',
    title: 'Key Performance Indicators',
    intro:
      'These cards give you an instant health check. Track your inbound and outbound message counts, scheduled interviews, total contacts, active users, and export a PDF report. The numbers update as you change the date range.',
  },
  {
    element: '#gh-dash-filter-bar',
    title: 'Date Range & Filters',
    intro:
      'Use the date picker to narrow the Dashboard down to a specific period \u2014 last 30 days, this month, or a custom range. You can also switch timezones and change the grouping (day, week, month) to see trends at the granularity that matters to you.',
  },
]

export const getInboxSteps = () => [
  {
    element: '.inboxSideMenu',
    title: 'Inbox Sidebar',
    intro:
      'This is where you manage all your conversations. Filter by Inbox, Sent, or Starred messages. You can also browse by Campaign, Tag, or Group to quickly find the threads you\u2019re looking for.',
  },
  {
    element: '.tour-inbox-conversations',
    title: 'Conversation List',
    intro:
      'Every text conversation with a candidate shows up here. Click any thread to open it on the right and see the full message history. Unread messages are highlighted so nothing slips through the cracks.',
  },
  {
    element: '.tour-inbox-reply',
    title: 'Message Composer',
    intro:
      'Type your reply and hit send \u2014 it\u2019s that simple. You can also schedule messages for later, insert a saved template, or attach media. If you have multiple numbers, choose which one to send from.',
  },
]

export const getContactsSteps = () => [
  {
    element: '.tour-contacts-header',
    title: 'Your Contact Database',
    intro:
      'Every candidate you\u2019ve communicated with \u2014 or imported \u2014 lives here. Search by name, phone number, or email to find anyone instantly. Use tags and groups to keep your pipeline organized.',
  },
  {
    element: '.tour-contacts-actions',
    title: 'Add, Import & Export',
    intro:
      'Add a single contact manually, bulk-import from a spreadsheet, or export your entire list to CSV. These buttons are your go-to tools for keeping your contact database up to date.',
  },
  {
    element: '.gh-themed-table .ant-table-thead',
    title: 'Contact Table',
    intro:
      'Browse, sort, and filter your contacts right from this table. Click any column header to sort, and click any row to open that contact\u2019s full profile with details, message history, groups, and tags.',
    position: 'bottom',
  },
]

export const getGroupsSteps = () => [
  {
    element: '.tour-groups-create',
    title: 'Groups',
    intro:
      'Groups let you organize contacts into audiences \u2014 by role, location, event, or anything else that makes sense for your recruiting. Create a custom group from scratch, or pick one of the quick-start templates to get going fast.',
  },
]

export const getTemplatesSteps = () => [
  {
    element: '.tour-templates-create',
    title: 'Message Templates',
    intro:
      'Stop retyping the same messages. Create a template once and reuse it everywhere \u2014 in the Inbox, in Campaigns, and in Interview Invites. Templates support mail-merge fields so each message feels personal.',
  },
  {
    element: '.tour-templates-tabs',
    title: 'My Templates & Library',
    intro:
      'The \u201cMy Templates\u201d tab shows templates you\u2019ve created. Switch to \u201cTemplate Library\u201d to browse pre-built options you can copy and customize. It\u2019s the fastest way to get started with proven messaging.',
  },
]

export const getInterviewInvitesSteps = () => [
  {
    element: '.tour-interview-tabs',
    title: 'Interview Invites',
    intro:
      'Automate your interview scheduling. Set up the invite message candidates will receive, connect your Google, Outlook, or Exchange calendar so availability updates in real time, and configure a confirmation flow for when they pick a slot.',
  },
]

export const getCampaignsSteps = () => [
  {
    element: '.tour-campaign-create',
    title: 'Broadcast Campaigns',
    intro:
      'Need to reach hundreds \u2014 or thousands \u2014 of contacts at once? Create a campaign, pick a group, write your message, and schedule it. GoHire handles the delivery and tracks opens, replies, and failures for you.',
  },
  {
    element: '.tour-campaign-templates',
    title: 'Campaign Templates',
    intro:
      'Don\u2019t start from a blank page. Choose from ready-made templates \u2014 Shift Availability, Interview Invite, Weather Alert, or Onboarding Welcome \u2014 and customize the message to fit your needs.',
  },
]

export const getApplyByTextSteps = () => [
  {
    element: '.tour-abt-overview',
    title: 'Apply by Text',
    intro:
      'Let candidates start a conversation just by scanning a QR code or texting a keyword. Design a branded hiring sign, download it as a PDF or image, and place it anywhere \u2014 job fairs, storefronts, or online postings.',
  },
]

export const getSettingsSteps = () => [
  {
    element: '.tour-settings-tabs',
    title: 'Account Settings',
    intro:
      'Manage your profile, update your password and security settings, choose which notifications you receive, and set your office hours so candidates know when to expect a reply. You\u2019re all set \u2014 happy recruiting!',
  },
]

